import { Button, Input, TextField } from "@mui/material";
import React, { useContext, useState } from "react";
import Select from "react-select";
import { AppContext } from "../../../context/AppContext";

export default function SearchQB(props) {
  const { batches, branches, courses, subjects, tags, topics, users, roles } =
    useContext(AppContext);

  const [approvedBy, setApprovedBy] = useState("");
  const [courseIds, setCourseIds] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [tagIds, setTagIds] = useState([]);
  const [topicIds, setTopicIds] = useState([]);
  const [createdBy, setCreatedBy] = useState("");
  const [questionComplexity, setQuestionComplexity] = useState({
    value: "ALL",
    label: "ALL",
  });
  const [numOfTimesUsedInExam, setNumOfTimesUsedInExam] = useState(0);
  const [createdDate, setCreatedDate] = useState(null);
  const [updatedDate, setUpdatedDate] = useState(null);
  const [issueReported, setIssueReported] = useState({
    value: false,
    label: "False",
  });
  const [includeQuestionsFromQB, setIncludeQuestionsFromQB] = useState({
    value: true,
    label: "True",
  });
  const [showFilter, setShowFilter] = useState(true);
  const [updatedBy, setUpdatedBy] = useState("")

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="text"
          style={{ margin: "0px" }}
          onClick={() => props?.setDisplayCharts(!props?.displayCharts)}
        >
          {" "}
          {props?.displayCharts ? "hide" : "show"} chart
        </Button>
        <Button
          variant="text"
          style={{ margin: "0px" }}
          onClick={() => setShowFilter(!showFilter)}
        >
          {" "}
          {showFilter ? "hide" : "show"} Advanced
        </Button>
      </div>

      {showFilter && (
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Subject</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={subjectIds}
                  options={subjects.map((el) => {
                    return {
                      value: el.subjectId,
                      label: el.subject,
                    };
                  })}
                  onChange={(item) => {
                    setSubjectIds(item);
                    if(item.length === 0) {
                      props.search({
                          approvedBy,
                          courseIds,
                          subjectIds,
                          tagIds,
                          topicIds,
                          createdBy,
                          updatedBy,
                          questionComplexity,
                          numOfTimesUsedInExam,
                          issueReported,
                          includeQuestionsFromQB,
                          createdDate,
                          updatedDate,
                        })
                    }
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Course</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={courseIds}
                  options={courses.map((el) => {
                    return {
                      value: el.courseId,
                      label: el.course,
                    };
                  })}
                  onChange={(item) => {
                    setCourseIds(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Tags</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={tagIds}
                  options={tags.map((el) => {
                    return {
                      value: el.tagId,
                      label: el.tagName,
                    };
                  })}
                  onChange={(item) => {
                    setTagIds(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Topics</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={topicIds}
                  options={topics.map((el) => {
                    return {
                      value: el.topicId,
                      label: el.topic,
                    };
                  })}
                  onChange={(item) => {
                    setTopicIds(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Created by</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={createdBy}
                  options={users.map((el) => {
                    return {
                      value: el.userID,
                      label: el.email,
                    };
                  })}
                  onChange={(item) => {
                    setCreatedBy(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Updated by</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={updatedBy}
                  options={users.map((el) => {
                    return {
                      value: el.userID,
                      label: el.email,
                    };
                  })}
                  onChange={(item) => {
                    setUpdatedBy(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Issue Reported</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={issueReported}
                  options={[
                    { value: true, label: "True" },
                    { value: false, label: "False" },
                  ]}
                  onChange={(item) => {
                    setIssueReported(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Include Questions From QB</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  value={includeQuestionsFromQB}
                  options={[
                    { value: true, label: "True" },
                    { value: false, label: "False" },
                  ]}
                  onChange={(item) => {
                    setIncludeQuestionsFromQB(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">

          <div class="form-sub-div">
              <label class="form-label">Approved by</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  value={approvedBy}
                  options={users.map((el) => {
                    return {
                      value: el.userID,
                      label: el.email,
                    };
                  })}
                  onChange={(item) => {
                    setApprovedBy(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Complexity</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={questionComplexity}
                  options={[
                    { value: "ALL", label: "ALL" },
                    { value: "EASY", label: "EASY" },
                    { value: "MEDIUM", label: "MEDIUM" },
                    { value: "HIGH", label: "HIGH" },
                  ]}
                  onChange={(item) => {
                    setQuestionComplexity(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">{`Created Date >`} </label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Input
                  type="date"
                  value={createdDate}
                  onChange={(item) => {
                    setCreatedDate(item.target.value);
                  }}
                />
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">
                {`num Of Times Used In Exam >=`}{" "}
              </label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Input
                  type="number"
                  value={numOfTimesUsedInExam}
                  onChange={(item) => {
                    setNumOfTimesUsedInExam(item.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">{`Updated Date >`} </label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Input
                  type="date"
                  value={updatedDate}
                  onChange={(item) => {
                    setUpdatedDate(item.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              style={{
                marginRight: "5px",
                marginBottom: "5px"
              }}
              onClick={() => {
                setApprovedBy("");
                setCourseIds([]);
                setSubjectIds([]);
                setTagIds([]);
                setTopicIds([]);
                setCreatedBy("");
                setUpdatedBy("");
                setQuestionComplexity({
                  value: "ALL",
                  label: "ALL",
                });
                setNumOfTimesUsedInExam(0);
                setCreatedDate(null);
                setUpdatedDate(null);
                setIssueReported({
                  value: false,
                  label: "False",
                });
                setIncludeQuestionsFromQB({
                  value: true,
                  label: "True",
                });
              }}
            >
              Reset
            </Button>
            <Button
              variant="outlined"
              style={{
                marginBottom: "5px"
              }}
              disabled={subjectIds.length === 0}
              onClick={() =>
                props?.search({
                  approvedBy,
                  courseIds,
                  subjectIds,
                  tagIds,
                  topicIds,
                  createdBy,
                  questionComplexity,
                  numOfTimesUsedInExam,
                  issueReported,
                  includeQuestionsFromQB,
                  createdDate,
                  updatedDate,
                  updatedBy
                })
              }
            >
              Search
            </Button>
          </div>
        </div>
       )} 
    </div>
  );
}
